import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '@/lib/auth';

const links = [
  { to: '/inbox', label: 'Inbox' },
  { to: '/subscriptions', label: 'Subscriptions' },
  { to: '/availability', label: 'Availability' },
  { to: '/settings', label: 'Settings' },
];

export function Layout() {
  const { developer, signOut } = useAuth();
  return (
    <div className="app-shell">
      <header className="topbar">
        <div className="brand">🚨 Reality Alerts</div>
        <nav className="nav">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}>
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="topbar-right">
          <span className="muted">{developer?.display_name}</span>
          <button className="btn btn-ghost" onClick={() => void signOut()}>Sign out</button>
        </div>
      </header>
      <main className="content">
        <Outlet />
      </main>
    </div>
  );
}
